module.exports = __webpack_public_path__ + "static/adventuretime-d17ff7f24f84b15c69d8ebaeadd280e0.gif";